import React from 'react'

const UserSettingsSkeleton = () => (
  <div className="flex h-fit w-full flex-col gap-2 overflow-x-hidden rounded-md bg-background-secondary md:gap-5">
    <div className="h-[64px] bg-brand-primary-subtle p-5">
      <div className="animate-pulse rounded bg-skeleton-primary text-transparent">.</div>
    </div>
    <div className="flex animate-pulse flex-col gap-7 px-5 pb-7 pt-5 md:gap-10 md:pb-10">
      <div className="flex flex-col justify-between gap-7 md:h-[66px] md:flex-row md:gap-10 [&>*]:flex-1">
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
        <div />
      </div>
      <div className="flex flex-col justify-between gap-7 md:h-[66px] md:flex-row md:gap-10 [&>*]:flex-1">
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
      </div>
      <div className="flex flex-col justify-between gap-7 md:h-[66px] md:flex-row md:gap-10 [&>*]:flex-1">
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
      </div>
      <div className="flex flex-col justify-between gap-7 md:h-[66px] md:flex-row md:gap-10 [&>*]:flex-1">
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
      </div>
      <div className="flex flex-col justify-between gap-7 md:h-[66px] md:flex-row md:gap-10 [&>*]:flex-1">
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
        <div className="my-3 rounded bg-skeleton-primary py-2.5 text-transparent md:py-0">.</div>
      </div>
      <div className="flex flex-col justify-between gap-7 md:h-[44px] md:flex-row md:gap-10 [&>*]:flex-1">
        <div className="my-2 rounded bg-skeleton-primary py-1 text-transparent md:py-0">.</div>
      </div>
    </div>
  </div>
)

export default UserSettingsSkeleton
